import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import Komunikaty from "@/components/Komunikaty";
import Wiadomosci from "@/components/Wiadomosci";
import AdBanner from "@/components/AdBanner";
import OgloszeniaTeaser from "@/components/OgloszeniaTeaser";
import Grupa from "@/components/Grupa";
import FAQ from "@/components/FAQ";
import CommunityEngagement from "@/components/CommunityEngagement";
import Kontakt from "@/components/Kontakt";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import ReportBanner from "@/components/ReportBanner";
import ReportFloatingButton from "@/components/ReportFloatingButton";
import useSeo from "@/hooks/useSeo";

export default function HomePage() {
    useSeo({});  // uses defaults from /api/settings

    return (
        <div data-testid="home-page" className="min-h-screen bg-[#FDFDFD] text-[#111827]">
            <Navbar />
            <main>
                <Hero />
                <Stats />
                <Wiadomosci />
                <ReportBanner />
                <Komunikaty />
                <AdBanner />
                <OgloszeniaTeaser />
                <Grupa />
                <FAQ />
                <CommunityEngagement />
                <Kontakt />
            </main>
            <Footer />
            <CookieConsent />
            <ReportFloatingButton />
        </div>
    );
}
